import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type fieldsetGroupElementsType = {
  fieldset: SxProps
  legend: SxProps
  legendText: SxProps
  buttonsWrapper: SxProps
}

export const fieldsetGroupStyles: fieldsetGroupElementsType = {
  fieldset: {
    paddingBottom: theme.spacing(1.5),
    marginBottom: theme.spacing(2.5),

    '&.secondary-type': {
      paddingBottom: theme.spacing(2.5),
      marginBottom: 0
    },

    '&:last-child': {
      paddingBottom: 0,
      marginBottom: 0
    }
  },

  legend: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 0, 2, 0),

    '.secondary-type &': {
      padding: theme.spacing(0.5, 1, 0.5, 3),
      backgroundColor: theme.colors.gray15,
      borderRadius: '8px',
      marginBottom: theme.spacing(1.5)
    }
  },

  legendText: {
    flex: '1 1 auto',
    color: theme.corporate.primaryColor,
    fontFamily: theme.corporate.primaryFont,
    fontSize: 18,
    fontWeight: 700,
    lineHeight: '20px',

    '.secondary-type &': {
      color: theme.colors.gray14,
      fontSize: 16
    }
  },

  buttonsWrapper: {
    flex: '0 0 auto',
    display: 'flex',

    '& .MuiSvgIcon-root': {
      fontSize: '22px',
      fill: theme.corporate.primaryColor
    },

    '& .Mui-disabled .MuiSvgIcon-root': {
      fill: theme.colors.gray16
    }
  }
}
